module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../node_modules/happypack/loader.js?id=jsx!./ShareGiftView.js"));
	}, "GiftWarehouseShareGiftView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=GiftWarehouseShareGiftView!./src/pages/Shop/Member/Personal/GiftWarehouse/ShareGift/ShareGiftView.js
// module id = 1017
// module chunks = 431